<gp-modal size="lg"
          [closable]="false"
          [onCancel]="cancelCallback"
          [onSubmit]="submitCallback"
          [form]="false">
  <div class="gp-modal-title">
    {{ 'ME.your_profile' | translate }}
  </div>
  <div class="gp-modal-body">
    <div *ngIf="user">
      <!-- header -->
      <div class="item">
        <div class="p-a-smd">
          <div class="row">
            <div class="padding">
              <div class="pull-left m-r-md" (click)="employee && avatarUploader.click()">
                <gp-user-avatar [pictureUri]="employee?.photoLink?.href"
                                [initials]="(user?.firstName?.charAt(0) || '') + (user?.lastName?.charAt(0) || '')"
                                size="lg"
                                classes="{{employee ? 'pointer hover-plus' : ''}}">
                </gp-user-avatar>
                <input #avatarUploader type="file" accept="image/*" (change)="photoSelected($event)" class="hide"/>
              </div>
              <div class="clear m-b">
                <h3 class="m-a-0 m-b-xs">{{ user.firstName }} <span class="font-weight-bold">{{ user.lastName }}</span>
                </h3>
                <p class="text-muted" *ngIf="user.lastConnection">
                  <i aria-hidden="true" class="fa fa-light fa-info-circle"></i>
                  {{ 'ME.last_connection_on_' | translate:{
                  lastConnection: user.lastConnection | gpDate: {
                    format: 'LLL',
                    timezone: this.user.timezone
                  }
                } }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- content block -->
      <div class="m-t-md">

        <div class="row">
          <div class="col-sm-12 col-md-6 p-y-sm">
            <small class="text-muted">{{ 'ME.login' | translate }}</small>
            <div class="_500">{{ user.login }}</div>
          </div>
          <div class="col-sm-12 col-md-6 p-y-sm">
            <small class="text-muted">{{ 'ME.title' | translate }}</small>
            <div class="_500">{{ user.title }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-6 p-y-sm">
            <small class="text-muted">{{ 'FORMS.first_name' | translate }}</small>
            <div class="_500">{{ user.firstName }}</div>
          </div>
          <div class="col-sm-12 col-md-6 p-y-sm">
            <small class="text-muted">{{ 'FORMS.last_name' | translate }}</small>
            <div class="_500">{{ user.lastName }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-6 p-y-sm">
            <small class="text-muted">{{ 'ME.user_email' | translate }}</small>
            <div class="_500">
              <input type="email"
                     class="email-input w-100"
                     [formControl]="mailControl"
                     email>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 p-y-sm">
            <small class="text-muted">{{ 'ME.phone_number' | translate }}</small>
            <div class="_500">{{ user.phoneNumber }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-6 p-y-sm">
            <small class="text-muted">{{ 'my_profile_email_enabling_text' | translate }}</small>
            <div class="_500 nowrap">
              <label class="ui-switch v-m">
                <input type="checkbox" [(ngModel)]="currentSendEmail" (change)="onChange($event.target)">
                <em></em>
              </label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-6 p-y-sm" test-id="profile_language">
            <small class="text-muted">{{ 'ME.your_language' | translate }}</small>
            <div class="_500">
              <gp-dropdown-select [ngModel]="currentLanguage"
                                  (ngModelChange)="selectedLocale = $event"
                                  buttonClasses="btn-sm"
                                  menuClasses="dropdown-menu-min"
                                  ngDefaultControl>
                <gp-dropdown-option *ngFor="let language of languages | keys"
                                    [ngValue]="language">
                  {{ languages[language] }}
                </gp-dropdown-option>
              </gp-dropdown-select>
            </div>
          </div>

          <div class="col-sm-12 col-md-6 p-y-sm" test-id="profile_time_zone">
            <small class="text-muted">{{ 'ME.your_timezone' | translate }}</small>
            <div class="_500">
              <gp-dropdown-select [ngModel]="currentTimezone"
                                  (ngModelChange)="selectTimezone($event)"
                                  menuClasses="dropdown-menu-min"
                                  buttonClasses="btn-sm"
                                  ngDefaultControl>
                <gp-dropdown-option *ngFor="let zone of timezoneNames"
                                    [ngValue]="zone.value">
                  {{ zone.name }}
                </gp-dropdown-option>
              </gp-dropdown-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-6 p-y-sm" test-id="profile_number_format">
            <small class="text-muted">{{ 'ME.your_numberFormat' | translate }}</small>
            <div class="_500">
              <gp-dropdown-select [ngModel]="currentNumberFormat"
                                  (ngModelChange)="selectNumberFormat($event)"
                                  menuClasses="dropdown-menu-min"
                                  buttonClasses="btn-sm"
                                  ngDefaultControl>
                <ng-container *ngFor="let decimalSymbol of numberDecimalSymbols">
                  <ng-container *ngFor="let separatorSymbol of numberSeparatorSymbols">
                    <gp-dropdown-option *ngIf="decimalSymbol !== separatorSymbol"
                                        [ngValue]="decimalSymbol + separatorSymbol">
                      1{{ separatorSymbol }}234{{ separatorSymbol }}567{{ decimalSymbol }}89
                    </gp-dropdown-option>
                  </ng-container>
                </ng-container>
              </gp-dropdown-select>
            </div>
          </div>

          <div class="col-sm-12 col-md-6 p-y-sm" test-id="profile_date_format">
            <small class="text-muted">{{ 'ME.your_dateFormat' | translate }}</small>
            <div class="_500">
              <gp-dropdown-select [ngModel]="currentDateFormat"
                                  (ngModelChange)="selectDateFormat($event)"
                                  menuClasses="dropdown-menu-min"
                                  buttonClasses="btn-sm"
                                  ngDefaultControl>
                <gp-dropdown-option *ngFor="let dateFormat of dateFormats" [ngValue]="dateFormat">
                  {{ dateFormat }}
                </gp-dropdown-option>
              </gp-dropdown-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-6 p-y-sm">
            <small class="text-muted">{{ 'ME.autoSave' | translate }}</small>
            <div class="_500">
              <label class="ui-switch v-m ">
                <input type="checkbox" [(ngModel)]="currentAutoSave" (ngModelChange)="selectAutoSave($event)">
                <em></em>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</gp-modal>
